import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler, // Import Filler for area chart
} from "chart.js";
import React from "react";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top" as const,
    },
    title: {
      display: false,
      text: "Chart.js Area Chart",
    },
  },
  elements: {
    line: {
      tension: 0.4, // Optional: curve the lines
      fill: true, // Enable filling the area
    },
  },
};

const LineChart = ({ data }: { data: any }) => {
  return <Line options={options} data={data} />;
};

export default LineChart;
